// extracted by mini-css-extract-plugin
module.exports = {"Main":"Br_Main___MK_k","Ribbon":"Br_Ribbon__Xsznr Br_Main___MK_k","MainDecorator":"Br_MainDecorator__c4uFA","RibbonDecorator":"Br_RibbonDecorator__1HhI8"};